import { useTranslation } from 'next-i18next'
import { twJoin, twMerge } from 'tailwind-merge'
import { LectureAssignmentIcon } from 'shared/icons/lecture-assignment-icon'
import { CourseMenuLectureInterface } from 'modules/course/types/course-menu-interface'
import { AssignmentsStatusTranslations } from '../../course-lecture-assignment/constants'
import { getAssignmentStatusTextColor } from '../../course-lecture-assignment/utils'

interface CourseLectureAssignmentStatusProps {
  lecture: CourseMenuLectureInterface
  isLectureCurrent: boolean
}

export const CourseLectureAssignmentStatus = ({
  lecture,
  isLectureCurrent,
}: CourseLectureAssignmentStatusProps) => {
  const { t } = useTranslation()

  return (
    <div
      className={twMerge(
        'ml-[26px] mt-1.5 flex items-center',
        isLectureCurrent && 'text-brand-primary',
      )}
    >
      <div>
        <LectureAssignmentIcon />
      </div>
      <span className="ml-1 mr-1.5">{t('course.lecture.assignment_text')}</span>
      {!!lecture.assignment?.status && (
        <p>
          <span>•</span>
          <span
            className={twJoin('ml-1.5', getAssignmentStatusTextColor(lecture.assignment.status))}
          >
            {t(AssignmentsStatusTranslations[lecture.assignment.status])}
          </span>
        </p>
      )}
    </div>
  )
}
